// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollable-container {
    display: flex;
    overflow-x: auto; /* Enables horizontal scrolling */
    white-space: nowrap; /* Prevent wrapping of child elements */
    /* margin-left: -2%; */
    /* border: 1px solid #ddd; Optional, for better visualization */
  }`, "",{"version":3,"sources":["webpack://./src/components/Settings/settings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB,EAAE,iCAAiC;IACnD,mBAAmB,EAAE,uCAAuC;IAC5D,sBAAsB;IACtB,+DAA+D;EACjE","sourcesContent":[".scrollable-container {\n    display: flex;\n    overflow-x: auto; /* Enables horizontal scrolling */\n    white-space: nowrap; /* Prevent wrapping of child elements */\n    /* margin-left: -2%; */\n    /* border: 1px solid #ddd; Optional, for better visualization */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
